module.exports = __webpack_public_path__ + "static/layers-panel-handoff-5135bb881c74171d57d21f3ffa6cc976.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/layers-panel-handoff.png
// module id = 2692
// module chunks = 157636680307020